import { Patterns } from "@omni/schemas/input/patterns";
import { LicensePlateType } from "@omni/types/enums/licensePlate.enum";
import * as yup from "yup";

import { Config } from "@/utils/config.utils";
import { string } from "@/utils/validation/schemas/general.RHF";

export const LicensePlateValidationSchema = yup.object({
    isPersonalized: yup.boolean().optional(),
    licensePlateType: yup
        .mixed<LicensePlateType>()
        .oneOf(Object.values(LicensePlateType))
        .required(),
    licensePlate: string().when(["licensePlateType"], {
        is: (licensePlateType: LicensePlateType) =>
            licensePlateType === LicensePlateType.Standard,
        then: (schema) =>
            schema.matches(
                Patterns[Config.general.basestore].licensePlate[
                    LicensePlateType.Standard
                ]
            ),
        otherwise: (schema) =>
            schema.matches(
                Patterns[Config.general.basestore].licensePlate[
                    LicensePlateType.Personalized
                ]
            )
    })
});

export type LicensePlateFormValues = yup.InferType<
    typeof LicensePlateValidationSchema
>;
